import React from 'react';
import useReminderState from './hooks/useReminderState';
import useReminderHandlers from './hooks/useReminderHandlers';
import ReminderList from './components/ReminderList';
import DeleteConfirmationDialog from './components/DeleteConfirmationDialog';

const Allreminders = ({
  allReminders,
  selectedPatient,
  fetchReminders,
  loading,
  onEditReminder,
}) => {
  // State management
  const {
    filteredReminders,
    setFilteredReminders,
    openDeleteDialog,
    setOpenDeleteDialog,
    reminderToDelete,
    setReminderToDelete,
    patientIdToDelete,
    setPatientIdToDelete,
  } = useReminderState(allReminders, selectedPatient);

  const {
    deleteReminderInFirebase,
    handleActiveReminderChange,
  } = useReminderHandlers(
    filteredReminders,
    setFilteredReminders,
    fetchReminders
  );

  const handleEdit = (data, patientId) => {
    if (onEditReminder) {
      onEditReminder(data, patientId);
    }
  };

  const handleDelete = (reminderId, patientId) => {
    if (reminderId && patientId) {
      setReminderToDelete(reminderId);
      setPatientIdToDelete(patientId);
      setOpenDeleteDialog(true);
    } else {
      console.error('Missing reminder data for deletion');
    }
  };

  const handleDeleteConfirm = () => {
    if (reminderToDelete && patientIdToDelete) {
      deleteReminderInFirebase(reminderToDelete, patientIdToDelete);
    }
    setOpenDeleteDialog(false);
    setReminderToDelete(null);
    setPatientIdToDelete(null);
  };

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setReminderToDelete(null);
    setPatientIdToDelete(null);
  };

  if (loading) {
    return (
      <div className='flexBox flexColumn flexCenter' style={{ height: '50vh' }}>
        <div className='loader' />
      </div>
    );
  }

  return (
    <div className='fullWidth fullHeight flexBox flexColumn' style={{ gap: 5 }}>
      <ReminderList
        filteredReminders={filteredReminders}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onActiveChange={handleActiveReminderChange}
      />

      <DeleteConfirmationDialog
        open={openDeleteDialog}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
        title='Are you sure you want to delete this reminder?'
      />
    </div>
  );
};

export default Allreminders;
